import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetSingleBlogger } from '../redux/user/blog/blogServicesSync';
import ShareButtons from './ShareButtons';

export default function BlogPost() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { singleStoryPageDetails: blog } = useSelector((state) => state.user_blog);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    dispatch(GetSingleBlogger({ Id: id }));
  }, [dispatch, id]);

  return (
    <div className="mx-auto px-4 py-8 flex flex-col md:flex-row gap-8">
      <main className="flex-1">
        <div className="blog__post--header mb-30">
          <h2 className="post__header--title mb-15">{blog?.title}</h2>
        </div>
        <div className="text-sm text-gray-600 mb-6">
          <p className='blog__post--meta'>
            Posted By : {blog?.fullname} | On : {new Date(blog?.createdAt).toLocaleDateString()} | In :
          </p>
          <span className="text-red-500 ml-1">{blog?.hash_tag}</span>
        </div>

        {/* Blog Image with Click Event */}
        <div className="blog__thumbnail mb-30">
          <img
            src={blog?.cover_pic}
            alt={blog?.title}
            className="w-full rounded-lg mb-6 cursor-pointer transition-transform hover:scale-105"
            onClick={() => setIsModalOpen(true)}
          />
        </div>

        {/* Modal for Enlarged Image */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-75 flex justify-center items-center z-50">
            <div className="relative">
              <button 
                className="absolute top-2 right-2 text-white bg-black rounded-full p-2"
                onClick={() => setIsModalOpen(false)}
              >
                ✕
              </button>
              <img
                src={blog?.cover_pic}
                alt={blog?.title}
                className="max-w-[90vw] max-h-[90vh] rounded-lg"
              />
            </div>
          </div>
        )}

        <div className="prose max-w-none mb-8" dangerouslySetInnerHTML={{ __html: blog?.article }} />
        
        <div className="flex items-center gap-4 mt-6">
          <span className="font-semibold">Social Share :</span>
          <ShareButtons />
        </div>
      </main>
    </div>
  );
}
